import { Checkbox } from '@trackman/web-shared-components';
import React from 'react';
import styled from 'styled-components';
import { darkgrey, grey, lightGrey } from 'styles/Colors';

export const PreferencesWrapper = styled.div``;

export const Headline = styled.div`
  color: ${darkgrey};
  font-family: Lato;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 25.2px;
  margin-bottom: 12px;
`;

export const RecordVideo = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Title = styled.div`
  font-weight: 700;
  font-size: 15px;
  color: ${darkgrey};
`;

export const Description = styled.div`
  font-size: 13px;
  color: #7b7b7b;
`;

export const ContentWrapper = styled.div`
  padding: 12px 16px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
`;

export const VideoWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const PlayerTrackingWrapper = styled.div`
  display: flex;
  margin-top: 5px;
`;

export const CheckboxDescription = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CheckboxHint = styled.div`
  font-size: 13px;
  color: ${lightGrey};
`;

export const StyledCheckbox = styled((props) => <Checkbox {...props} />)<{ disabled: boolean }>`
  &&& {
    .MuiFormControlLabel-label {
      font-weight: 700;
      font-size: 13px;
    }

    opacity: ${(props) => (props.disabled ? 0.6 : 1)};

    &.MuiFormControlLabel-root {
      height: unset;
      width: unset;
      margin-right: 12px;
    }
    svg {
      width: 16px;
      height: 16px;
    }
    .Mui-disabled {
      opacity: 0.5;
    }
  }
`;

export const PlayerTrackingHint = styled.div`
  font-size: 13px;
  color: ${grey};
  margin-top: 20px;
`;

export const OptionWrapper = styled.div`
  gap: 16px;
  display: flex;
  flex-direction: column;
  margin-bottom: 24px;
`;
